export default {
  path: '/search',
  auth: true,
  preload: false,
  key: 'search',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
